import { makeStyles } from "@mui/styles";
import { alpha } from "@mui/material/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  withSelectAll: {
    paddingTop: 36,
  },
  selectAll: {
    position: "fixed",
    width: "100%",
    left: 0,
    top: 0,
    zIndex: 10,
    minHeight: 36,
    cursor: "pointer",
    padding: "6px 16px",
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: alpha(theme.palette.action.active, theme.palette.action.activatedOpacity),
    backgroundColor: theme.palette.background.paper,
    borderRadius: "4px 4px 0 0",
  },

  borderedFlag: {
    width: 20,
    marginRight: 8,
    fontSize: 0,
    '& img': {
      width: 20,
      height: 'auto',
      border: `1px solid ${alpha(theme.palette.secondary.light, 0.2)}`,
    },
  },
  chipAvatar: {
    margin: '0 -4px 0 8px!important',
  },
  chipFlag: {
    display: 'flex',
    width: 18,
    height: 18,
    fontSize: 0,
    '& img': {
      width: 18,
      height: 'auto',
    },
  },

  option: {
    padding: "6px 16px",
    minHeight: "36px!important",
  },

  customScroll: {
    margin: '0 -92px 0px 0px',
    width: 'auto!important',
    '& .view': {
      display: 'flex',
      flexWrap: 'wrap',
      padding: '0 60px 0 0',
    },
    '& .track-vertical': {
      top: 0,
      bottom: 0,
      right: 2,
      borderRadius: '3px',
      backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity),
      '& > div': {
        position: 'relative',
        display: 'block',
        width: '100%',
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: `${alpha(theme.palette.secondary.light, 0.3)}!important`,
      }
    },
  },

  optionContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    width: '100%',
  },

  optionLabel: {
    display: 'block',
    width: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  blocked: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 4,
  }
}));
